import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const DotGridOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function DotGridOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M6.25 3h-3v3h3V3ZM13.75 3h-3v3h3V3ZM20.75 3h-3v3h3V3ZM6.25 10.5h-3v3h3v-3ZM13.75 10.5h-3v3h3v-3ZM20.75 10.5h-3v3h3v-3ZM6.25 18h-3v3h3v-3ZM13.75 18h-3v3h3v-3ZM20.75 18h-3v3h3v-3Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default DotGridOutlined;